import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { LeadViewAllTabsProps } from "./lead-view-all-tabs-props";
import { CustomTabPanelComponent } from "../../../common/components";
import LeadViewDetails from "./lead-view-details/lead-view-details";
import LeadViewAdditionalDetails from "./lead-view-additional-details/lead-view-additional-details";
import LeadViewTimeline from "./lead-view-timeline/lead-view-timeline";
import LeadViewDetailsViewAttachmentInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-attachment-info/lead-view-details-view-attachment-info";
import LeadViewDetailsViewOpenActivitiesInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-open-activities-info/lead-view-details-view-open-activities-info";
import LeadViewDetailsViewEmailInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-email-info/lead-view-details-view-email-info";
import LeadViewDetailsViewCampaignsInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-campaigns-info/lead-view-details-view-campaigns-info";
import "./lead-view.scss";
import { useLogin } from "../../../common/hooks/useUser";

const LeadViewDetailsAllTabs: React.FC<LeadViewAllTabsProps> = ({
  leadDetails,
  selectedLeadId,
  setLoading,
  viewFullInfoOpen,
  setViewFullInfoOpen,
  uploadedImage,
  setUploadedImage,
  uploadedImageFile,
  setUploadedImageFile,
  setRemoveImage,
  removeImage,
  fetchLeadDetails,
  leadId,
  onLeadNameUpdate,
  resetImageUpload,
  setAlertMessage,
  setAlertType,
  setAlertOpen,
  viewAddFullInfoOpen,
  setViewAddFullInfoOpen,
  disableLeadStatus,
  permissions,
  setCrumbMappingOption,
  setViewTaskvalue,
  setViewMeetingvalue,
  setViewCallValue,
  setUploadError
}) => {
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [viewEditOpen, setViewEditOpen] = useState<boolean>(false);
  const [indexValue, setIndexValue] = React.useState(0);
  const [updatedDate, setUpdatedDate] = useState<string | undefined>();
  const [disableEdit, setDisableEdit] = useState<boolean>(false);
  const { tenantDetails } = useLogin();

  const handleMainTabChange = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setIndexValue(newValue);
    setViewFullInfoOpen(false);
    setViewAddFullInfoOpen(false);
  };

  const handleEditOpen = () => {
    setViewEditOpen(true);
  };

  const handleFormSubmitError = (from?: any) => {
    if ("additionalDetails" === from) {
      setViewAddFullInfoOpen(true);
      setIndexValue(1);
      setAlertMessage(
        "Validation error in additional details tab. Please check the fields."
      );
      setAlertType("error");
      setAlertOpen(true);
    } else {
      setViewFullInfoOpen(true);
      setIndexValue(0);
      setAlertMessage(
        "Validation error in details tab. Please check the fields."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
    setUploadError(null);
  };

  useEffect(() => {
    if (
      tenantDetails?.tenantType === "SuperTenant" &&
      leadDetails?.assigned_to &&
      leadDetails?.lead_status !== "Closed-Lost"
    ) {
      setDisableEdit(true);
    }
    else if (tenantDetails?.tenantType === "Tenant"
      && leadDetails?.lead_status === "Closed-Lost" 
      && leadDetails?.lead_source === "AFP"
    ) {
      setDisableEdit(true);
    }
    else setDisableEdit(false);
  }, [leadDetails]);

  useEffect(() => {
    setUploadError(null);
  }, [indexValue, viewFullInfoOpen]);

  return (
    <div className="leads-view-all-tabs">
      <div className="lead-list-view-tab-edit">
        <div className="lead-list-view-tab-section">
          <Box>
            <Tabs
              value={indexValue}
              onChange={handleMainTabChange}
              allowScrollButtonsMobile
              variant="scrollable"
            >
              <Tab label="Details" />
              <Tab label="Additional Details" />
              <Tab label="Attachments" />
              {/* <Tab label="Products" /> */}
              <Tab label="Activities" />
              {/* <Tab label="Open Activities" />
              <Tab label="Closed Activities" /> */}
              {/* <Tab label="Invited Meetings" /> */}
              <Tab label="Communications" />
              <Tab label="Campaigns" />
              <Tab label="Timeline" />
            </Tabs>
          </Box>
        </div>
      </div>
      <div>
        <CustomTabPanelComponent value={indexValue} index={0}>
          <LeadViewDetails
            leadDetails={leadDetails}
            selectedLeadId={selectedLeadId}
            setLoading={setLoading}
            viewFullInfoOpen={viewFullInfoOpen}
            setViewFullInfoOpen={setViewFullInfoOpen}
            uploadedImage={uploadedImage}
            setUploadedImage={setUploadedImage}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            setRemoveImage={setRemoveImage}
            removeImage={removeImage}
            fetchLeadDetails={fetchLeadDetails}
            onLeadNameUpdate={onLeadNameUpdate}
            resetImageUpload={resetImageUpload}
            handleFormSubmitError={handleFormSubmitError}
            disableLeadStatus={disableLeadStatus}
            permissions={permissions}
            setUploadError ={ setUploadError}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={1}>
          <LeadViewAdditionalDetails
            leadDetails={leadDetails}
            selectedLeadId={selectedLeadId}
            setLoading={setLoading}
            viewFullInfoOpen={viewAddFullInfoOpen}
            setViewFullInfoOpen={setViewAddFullInfoOpen}
            uploadedImage={uploadedImage}
            setUploadedImage={setUploadedImage}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            setRemoveImage={setRemoveImage}
            removeImage={removeImage}
            fetchLeadDetails={fetchLeadDetails}
            onLeadNameUpdate={onLeadNameUpdate}
            resetImageUpload={resetImageUpload}
            handleFormSubmitError={handleFormSubmitError}
            permissions={permissions}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={2}>
          <LeadViewDetailsViewAttachmentInfo
            setLoading={setLoading}
            leadId={leadId}
            disableEdit={disableEdit}
            permissions={permissions}
            leadDetails={leadDetails}
          />
        </CustomTabPanelComponent>
        {/* <CustomTabPanelComponent value={indexValue} index={3}>
          <LeadViewDetailsViewProductInfo
            disableEdit={disableEdit || !permissions?.canWrite}
          />
        </CustomTabPanelComponent> */}
        <CustomTabPanelComponent value={indexValue} index={3}>
          <LeadViewDetailsViewOpenActivitiesInfo
            disableEdit={disableEdit || !permissions?.canWrite}
            leadDetails={leadDetails}
            setViewTaskvalue={setViewTaskvalue}
            setCrumbMappingOption={setCrumbMappingOption}
            permissions={permissions}
            setViewMeetingvalue={setViewMeetingvalue}
            setViewCallValue={setViewCallValue}

          />
        </CustomTabPanelComponent>
        {/* <CustomTabPanelComponent value={indexValue} index={4}>
          <LeadViewDetailsViewClosedActivitiesInfo
            disableEdit={disableEdit || !permissions?.canWrite}
          />
        </CustomTabPanelComponent> */}
        {/* <CustomTabPanelComponent value={indexValue} index={6}>
          <LeadViewDetailsViewInvitedMeetingsInfo disableEdit={disableEdit} />
        </CustomTabPanelComponent> */}
        <CustomTabPanelComponent value={indexValue} index={4}>
          <LeadViewDetailsViewEmailInfo
            disableEdit={disableEdit || !permissions?.canWrite}
            leadDetails={leadDetails}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent
          value={indexValue}
          index={5}
          isCampaigns={true}
        >
          <LeadViewDetailsViewCampaignsInfo
            allLeadData={selectedLeadId}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            disableEdit={disableEdit || !permissions?.canWrite}
            leadDetails={leadDetails}
          />
        </CustomTabPanelComponent>
        <CustomTabPanelComponent value={indexValue} index={6}>
          <LeadViewTimeline
            selectedLeadId={selectedLeadId}
            setLoading={setLoading}
            setUpdatedDate={setUpdatedDate}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
          />
        </CustomTabPanelComponent>
      </div>
    </div>
  );
};

export default LeadViewDetailsAllTabs;
